/**
 * Firestore yardımcı fonksiyonlar.
 * Tip dönüşümleri, timestamp yönetimi.
 */

import { Timestamp, serverTimestamp } from 'firebase/firestore'
import type { FieldValue } from 'firebase/firestore'

/** Yeni doküman için server timestamp */
export function nowServer(): FieldValue {
  return serverTimestamp()
}

/** Firestore Timestamp'i JS Date'e çevirir */
export function tsToDate(ts: Timestamp | undefined | null): Date | null {
  if (!ts) return null
  return ts.toDate()
}

/** Firestore Timestamp'i tarih string'e çevirir (TR formatı) */
export function tsToTrTarih(ts: Timestamp | undefined | null): string {
  const date = tsToDate(ts)
  if (!date) return '-'
  return date.toLocaleDateString('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}
